import React from "react";
import { LottiePlayer } from "../../../lottie-player/LottiePlayer";
import { Header, SlideLayout, Text } from "../../shared-components";
import LunchAnimation from "./assets/lunch-full.lottie";
export const LunchSlide = () => {
  return (
    <SlideLayout>
      <Header> Protect your lunch break </Header>
      <Text>
        Clockwise protects your lunch break on even the most packed days. You can always edit these
        settings later.
      </Text>
      <div className="cw-px-4 ">
        <LottiePlayer autoplay loop={1} src={LunchAnimation} className="lg:cw-h-[400px]" />
      </div>
    </SlideLayout>
  );
};
